// removed by extract-text-webpack-plugin
module.exports = {"pagSeguroLogo":"eN4dF"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/PagSeguroIcon/PagSeguroIcon.scss
// module id = 279
// module chunks = 0 1